import { useGtag } from "vue-gtag-next";
import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";
import { isAndroid } from "@/apps/core-app-onboarding/helpers/platformChecker.helper";
import { apiClient } from "@/apps/core-app-onboarding/services/apiClient/apiClient";
import { coreAppOnboardingApiUrls as apiUrl } from "@/apps/core-app-onboarding/services/apiClient/apiUrl";
import { jsonHeader } from "@/apps/core-app-onboarding/services/apiClient/apiHeader";

declare const Android: AndroidInterface;

interface ILogEventRequest {
  applicationId: string;
  logData?: Record<string, unknown>;
}

export const logAnalyticsEvent = (
  name: string,
  category: string,
  label?: string,
  data?: Record<string, string | number | boolean | null | undefined>,
  callback?: (x: unknown) => void
): void => {
  const applicationId = Android.getCreditLineApplicationId();
  if (applicationId != "") {
    if (isAndroid()) {
      const googleEventData = {
        event_category: category,
        event_label: label,
        engagement_time_msec: 1,
        applicationId,
        ...data,
      };
      const { event } = useGtag();
      event(name, googleEventData);
    }

    const apiUrls = apiUrl();

    const logEventRequest: ILogEventRequest = {
      applicationId,
      logData: {
        event: name,
        additionalData: { data, label },
      },
    };

    apiClient
      .post(
        apiUrls.LOG_EVENT,
        logEventRequest,
        jsonHeader(JSON.stringify(logEventRequest))
      )
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((error) => {
        console.log("log error", error);
      })
      .finally(() => {
        if (callback) {
          callback(undefined);
        }
      });
  }
};

export default logAnalyticsEvent;
